
<app-header-title>
  <span title>{{'addemployee.ApproveEmployeeResignation' | translate}}</span>
</app-header-title>



<div class="publicsetting" style="padding: 0rem 3rem;">
    <dx-data-grid #grid
      class="dx-card wide-card" 
      [dataSource]="customDataSource" 
      [showBorders]="false" 
      keyExpr="id"
      [focusedRowEnabled]="true" 
      [focusedRowIndex]="0" 
      [allowColumnResizing]="true" 
      [columnAutoWidth]="true"
      [columnHidingEnabled]="true" 
      [showColumnLines]="false" 
      [rowAlternationEnabled]="true" 
      [showRowLines]="false"
      [showBorders]="false" 
      [errorRowEnabled]="false" 
      [rtlEnabled]="currentLang === 'ar'"
      [repaintChangesOnly]="true"
      [editing]="editingConfig"
       (onRowUpdated)="onRowUpdated($event)"
    >

<!-- <dxo-editing mode="row" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="false"></dxo-editing> -->

<dxo-editing mode="cell" 
[allowAdding]="false" 
[allowUpdating]="true" [allowDeleting]="false">
            </dxo-editing>

      <dxo-remote-operations [groupPaging]="true"></dxo-remote-operations>
      <dxo-pager [visible]="true"></dxo-pager>
          
      <dxo-paging [pageSize]="10"></dxo-paging>
  
      <dxo-pager 
        [visible]="true" 
        allowedPageSizes="true" 
        displayMode="full" 
        [showPageSizeSelector]="true" 
        [showInfo]="false" 
        [showNavigationButtons]="true">
      </dxo-pager>
      
      <dxo-filter-row [visible]="true"></dxo-filter-row>

         <dxi-column dataField="employeeId" caption="{{'tableinfo.employee'|translate}}" [allowEditing]="false">
      <dxo-lookup [dataSource]="employeeDropDown" valueExpr="id"
        [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
    </dxi-column>    
      <dxi-column dataField="status" caption="{{'salary.status'|translate}}" [allowEditing]="true">
      <dxo-lookup [dataSource]="employeeStatus" valueExpr="code" displayExpr="name"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="resignationReason" caption="{{'tableinfo.description'|translate}}" [allowEditing]="false"></dxi-column>
    <dxi-column dataField="branchName" caption="إســـــم الـفـرع" [allowEditing]="false"></dxi-column>
    <dxi-column dataField="notionalId" caption="الــرقــم الــقــومــي"  [allowEditing]="false"></dxi-column>
    <dxi-column dataField="userName" caption="إســــم الــمــســتـخـدم"  [allowEditing]="false"></dxi-column>
    <dxi-column dataField="date" dataType="date" [allowEditing]="false"
      caption="{{'tableinfo.dateOfRegistration'|translate}}"></dxi-column>
              <dxi-column type="buttons" caption="{{'approval.approval'|translate}}" [visible]="approvepermission">
      <dxi-button
        text="{{ 'approval.approval' | translate }}"
        [onClick]="submitapproval">
      </dxi-button>

    </dxi-column>

    </dx-data-grid>
  </div>
  